// angular
import { Component, ElementRef, Input, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { concatMap, from, tap } from 'rxjs';
import { CoreService } from '../../../core/core.service';
import { AppService } from '../../../app.service';
import { MeDynamicReportService } from '../dynamic-report.service';
import { KlenicoMeService } from '../../me.service';
import {
    animate,
    state,
    style,
    transition,
    trigger
} from '@angular/animations';

@Component({
    selector: 'me-dynamic-patient-sub-cluster',
    templateUrl: './sub-cluster.component.html',
    styleUrls: ['./sub-cluster.component.scss'],
    providers: [MeDynamicReportService],
    animations: [
        trigger('fillAnimation', [
            state('true', style({
                width: '{{percent}}%',
            }),  {params: {percent: 1}}),
            state('false',   style({
                width: '0px',
            })),
            transition('true => false', animate('600ms ease-out')),
            transition('false => true', animate('600ms ease-in'))
        ])
    ]
})

export class MeDynamicSubClusterComponent implements OnInit {
    activeSubCluster: any;
    items = [];
    url = 'dynamic-report/clusters/';
    chartData : any;
    activeClusterId = '';
    pageColor = '#ffffff';
    feelingCluster = [];
    subClusterFeelingIds = [];
    totalRating = [];
    voiceUrl;
    voiceData = '';
    ratingText = '';
    animationFilled = false;

    constructor(
        public translate: TranslateService,
        public appService: AppService,
        public router: Router,
        public route: ActivatedRoute,
        public coreService: CoreService,
        public meService: KlenicoMeService,
        public elementRef: ElementRef,
        public meDynamicReportService: MeDynamicReportService
    ) {
       
    }

    ngOnInit() {
        this.appService.isLoading = true;
        this.route.params.subscribe(params => {
            this.activeClusterId = params['subClusterId'];
            this.url = this.url + params['slug'];
            this.getClusterContent();
        })

        this.translate.onLangChange.subscribe(value => {
            this.voiceUrl = null;
            this.voiceData = '';
            this.translate.get('Intensity of feelings').subscribe(value => {
                this.ratingText = value;
             });
            this.getClusterContent();
        });

        this.translate.get('Intensity of feelings').subscribe(value => {
           this.ratingText = value;
        });
    }

    getClusterContent() {
        this.appService.getStoryBlokDataForClinic(this.url).subscribe(res => {
            let contents = res['story']['content'] ?? [];
            this.pageColor = contents['color']['color'];
            contents.subClusters.forEach(subCluster => {
                if (subCluster._uid === this.activeClusterId) {
                    this.activeSubCluster = subCluster;
                    this.getDynamicReportRating();
                }
            });
        });
    }

    getDynamicReportRating() {
        this.feelingCluster = [];
        this.meDynamicReportService.getDynamicReportRating().subscribe(res => {
            let ratingFeelings = res['data'];

            this.voiceData += this.activeSubCluster.name + '\n';
            let clusterText = this.meService.docToText(this.activeSubCluster.description);
            this.voiceData += clusterText;
            this.voiceData += '\n';

            // Get cluster feelings
            this.activeSubCluster.feelings.forEach(clusterFeeling => {
                let clusterFeelingIds = clusterFeeling.feelingIds.split(', ');
                let totalRating = 0;
                ratingFeelings.forEach(ratingFeeling => {
                    if (clusterFeelingIds.indexOf(ratingFeeling.feeling_id.toString()) >= 0) {
                        totalRating += ratingFeeling['severity'];
                    }
                });

                // Get article and calculate percent
                if (totalRating > 0){
                    let articles = [];
                    if(Array.isArray(clusterFeeling.linkedArticles)) {
                        from(clusterFeeling.linkedArticles).pipe(
                            concatMap(id => this.appService.getStoryBlokSlugByUuid(id)),
                            ).subscribe( response => {
                                articles.push(response['story']);
                            },
                            () => {},
                            () => {
                                clusterFeeling.rating = Math.ceil((totalRating / (clusterFeelingIds.length)) / 10) * 10;
                                clusterFeeling.articles = articles;
                                this.feelingCluster.push(clusterFeeling);
                                let clusterFeelingText = this.meService.docToText(clusterFeeling.description);
                                this.voiceData += clusterFeeling.name + '\n' + clusterFeelingText + '\n' + this.ratingText + '\n' + clusterFeeling.rating + '\n';
                            }
                        );
                    } else {
                        clusterFeeling.rating = Math.ceil((totalRating / (clusterFeelingIds.length)) / 10) * 10;
                        clusterFeeling.articles = articles;
                        this.feelingCluster.push(clusterFeeling);
                        let clusterFeelingText = this.meService.docToText(clusterFeeling.description);
                        this.voiceData += clusterFeeling.name + '\n' + clusterFeelingText + '\n' + this.ratingText + '\n' + clusterFeeling.rating + '\n';
                    }
                }
            });
            this.animationFilled = true;
            this.appService.isLoading = false;
        });
    }

    toTop() {
        (document.getElementById('me-dynamic-report-sub-cluster') as HTMLElement).scrollIntoView({behavior: "smooth", block: "start", inline: "nearest"});
    }

    getSpeech() {
        if(this.voiceUrl) {
            return;
        }

        this.meDynamicReportService.getSpeech(this.voiceData).subscribe(res => {
            this.voiceUrl = res['url'];
            
            setTimeout(() => {
                this.elementRef.nativeElement.querySelector('audio').play();
            }, 500)
        });
    }

    openDetail(article) {
        this.router.navigate(['/me/article/' + article.slug]);
    }
}
